import { render, staticRenderFns } from "./bookingOrderCom.vue?vue&type=template&id=1696f45e&scoped=true"
import script from "./bookingOrderCom.vue?vue&type=script&lang=js"
export * from "./bookingOrderCom.vue?vue&type=script&lang=js"
import style0 from "./bookingOrderCom.vue?vue&type=style&index=0&id=1696f45e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1696f45e",
  null
  
)

export default component.exports